import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FormHelperText } from '@material-ui/core';
import { AccordionSetup } from '@commonClient2/components';
import { UPDATE_GLOBAL_SETUP } from '../../store/globalSetup';
import { fetchAdminAppData } from '../../store/appData';
import ToggleNumericSetting from '../ToggleNumericSetting';
import './ManagersArchiveSettings.scss';

/**
 * @param {{
 *  isLoading: boolean;
 *  step: number;
 *  globalSetups: GlobalSetup.GlobalSetup;
 * }}
 * param0  */
const ManagersArchiveSettings = (
    { 
        isLoading, step, globalSetups
    }
) => {
    const isEnabledManagersAutoArchiveSignedOffBidsDelayName = 'isManagersAutoArchiveOnSignedOffBidEnabled';
    const managersAutoArchiveSignedOffBidsDelayName = 'managersSignedOffBidAutoArchiveNumberOfDays';
    const isEnabledManagersAutoArchiveCancelledBidsDelayName = 'isManagersAutoArchiveOnCancelledBidEnabled';
    const managersAutoArchiveCancelledBidsDelayName = 'managersCancelledBidAutoArchiveNumberOfDays';

    const { t } = useTranslation('globalSetup', { keyPrefix: 'managersArchive' });
    const { t: tCommon } = useTranslation('common');
    const dispatch = useDispatch();
    const { managersArchiveSettings: rules } = globalSetups;
    const {
        isManagersAutoArchiveOnCancelledBidEnabled,
        managersCancelledBidAutoArchiveNumberOfDays,
        isManagersAutoArchiveOnSignedOffBidEnabled,
        managersSignedOffBidAutoArchiveNumberOfDays
    } = rules;
    
    /** @type {ShiftBidding.AdminStore} */
    // @ts-ignore
    const { adminAppData } = useSelector((state) => state);
    const { isAdminAppDataLoaded, setups } = adminAppData;

    const isSetupWithRebidsAllowedExist = setups.some((x) => x.isRebidAllowed);
    useEffect(() => {
        if (!isAdminAppDataLoaded) {
            dispatch(fetchAdminAppData());
        }
    }, []);

    /**
     * @template T
     * @param {T} value
     */
    const updateStore = (value) => {
        dispatch({
            type: UPDATE_GLOBAL_SETUP,
            payload: { managersArchiveSettings: value },
        });
    };

    /**
     * @param {string} field
     * @param {*} value
     */
    const onChange = (field, value) => {
        updateStore({ ...rules, [field]: value });
    };

    /**
     * @param {string} toggleField
     * @param {string} inputField
     * @param {number} value
     * @param {boolean} checked
     */
    const onToggleChange = (toggleField, inputField, value, checked) => {
        if (!checked) {
            value = 0;
        }
        updateStore({ ...rules, [toggleField]: checked, [inputField]: value });
    };

    return (
        <AccordionSetup
            stepIndex={step.toString()}
            headerTitle={t('title')}
            summary=""
            className="managers-archive-step"
        >
            <div>
                <ToggleNumericSetting
                    toggleName={isEnabledManagersAutoArchiveSignedOffBidsDelayName}
                    inputName={managersAutoArchiveSignedOffBidsDelayName}
                    toggleValue={isManagersAutoArchiveOnSignedOffBidEnabled}
                    inputValue={managersSignedOffBidAutoArchiveNumberOfDays}
                    isDisabled={isLoading}
                    label={t('setAutoArchiveOnSignedOffBids')}
                    unitLabel={tCommon('days')}
                    isInputDisabled={!isManagersAutoArchiveOnSignedOffBidEnabled}
                    onToggleChange={(e) => {
                        onToggleChange(
                            isEnabledManagersAutoArchiveSignedOffBidsDelayName,
                            managersAutoArchiveSignedOffBidsDelayName,
                            managersSignedOffBidAutoArchiveNumberOfDays,
                            e.target.checked
                        );
                    }}
                    onNumberChange={(e) => {
                        onChange(managersAutoArchiveSignedOffBidsDelayName, Number(e.target.value));
                    }}
                    showWarning={isManagersAutoArchiveOnSignedOffBidEnabled}
                    isSetupWithRebidsAllowedExist={isSetupWithRebidsAllowedExist}
                />
                <ToggleNumericSetting
                    toggleName={isEnabledManagersAutoArchiveCancelledBidsDelayName}
                    inputName={managersAutoArchiveCancelledBidsDelayName}
                    toggleValue={isManagersAutoArchiveOnCancelledBidEnabled}
                    inputValue={managersCancelledBidAutoArchiveNumberOfDays}
                    isDisabled={isLoading}
                    label={t('setAutoArchiveOnCancelledBids')}
                    unitLabel={tCommon('days')}
                    isInputDisabled={!isManagersAutoArchiveOnCancelledBidEnabled}
                    onToggleChange={(e) => {
                        onToggleChange(
                            isEnabledManagersAutoArchiveCancelledBidsDelayName,
                            managersAutoArchiveCancelledBidsDelayName,
                            managersCancelledBidAutoArchiveNumberOfDays,
                            e.target.checked
                        );
                    }}
                    onNumberChange={(e) => {
                        onChange(managersAutoArchiveCancelledBidsDelayName, Number(e.target.value));
                    }}
                    showWarning={isManagersAutoArchiveOnCancelledBidEnabled}
                    isSetupWithRebidsAllowedExist={isSetupWithRebidsAllowedExist}
                />
                <FormHelperText className="info">{t('autoArchiveBidsInfo')}</FormHelperText>
            </div>
        </AccordionSetup>
    );
};

export default ManagersArchiveSettings;
